import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import useRestartXHR from '../../../hooks/useRestartXHR';
import useShow from '../../../hooks/useShow';
import {copy, qr, search, share} from '../../../assets/symbols/symbols/Symbols.css';
import {useEffect, useRef} from 'react';
import {getEventSettings, getPromotionMessage, updateHidePublishPopup} from '../../../redux/event/eventActions';
import * as css from '../popupAfterAdvertise.css';
import MobilePopup from '../../newPopup/mobilePopup/MobilePopup';
import Btn from '../../button/btn/Btn';
import BottomSection from '../privateEvent/BottomSection';
import QrCodePopup from '../../../layout/eventMenu/formButtton/QrCodePopup/QrCodePopup';
import PromotionSection from '../promotionSection/PromotionSection';
import {colors} from '../../managePromotion/ManagePromotion';
import CustomSharePopup from '../../customSharePopup/CustomSharePopup';
import useAdvertiseActions from '../../../hooks/useAdvertiseActions';
import {useField} from 'formik';
import PublicationSection from '../publicationSection/PublicationSection';
import CustomScrollbar from '../../customScrollbar/CustomScrollbar';
import zIndex from '../../../globalVariables/zIndex';
import Checkbox from '../../checkbox/Checkbox';
import {DEFAULT_COLOR} from '../../../globalVariables/GlobalVariables';

const AdvertiseContent = ({close, showClass, updateGoogleIndex} : {close: () => void; showClass: string; updateGoogleIndex: (value: boolean) => void;}) => {
    const {t} = useTranslation('event');
    const isIndexedXHR = useSelector((s: any) => s.forms.eventSettings.isIndexedXHR);
    const pmid = useSelector((state: any) => state.event.promotionMessage?.pmid);
    const {name, type, domain, landingPageUrl, settings, addGooglePingXHR, getEventSettingsXHR} = useSelector((s: any) => s.event);
    const {isIndexed} = settings.event;
    const {copyText,  handleCopyLink, handleGooglePing, getQrCodeUrl} = useAdvertiseActions({domain, landingPageUrl, name, type});
    const [{value: privateEvent}] = useField('privateEvent');
    const hidePublishPopup = settings.event.hidePublishPopup;

    useRestartXHR(isIndexedXHR, 'forms.eventSettings.isIndexedXHR');
    useRestartXHR(addGooglePingXHR, 'event.addGooglePingXHR');

    const showPromotion = useShow();
    const showPromotionPopup = useShow();
    const QRShow = useShow();
    const shareShow = useShow();
    const addPingXHR = isIndexed && (addGooglePingXHR || isIndexedXHR);
    const refContent = useRef(null);

    const btnArr = [
        {text: t('share'), onClick: shareShow.open, icon: share},
        {text: copyText || t('copyLink'), onClick: () => handleCopyLink(t('copied'), t('copyLink')), icon: copy, className: 'white'},
        {text: addPingXHR === 'SUCCESS' ? t('advertised') : isIndexed ? t('publishAgain') : t('googleAdvertising'), onClick: () => handleGooglePing(isIndexed, updateGoogleIndex), icon: search, className: `${addPingXHR} white`, disabled: privateEvent},
        {text: t('downloadQR'), onClick: QRShow.open, icon: qr, className: 'white'}
    ];
    useEffect(() => {
        if(!getEventSettingsXHR) {
            getEventSettings();
        }
        getPromotionMessage('publish').then();
    }, []);
    useEffect(() => {
        if(pmid) {
            showPromotion.open();
        }
    }, [pmid]);
    const cssStyle = `
        inset-inline-end: 5px;
        inset-block-start: 30px;
        z-index: ${zIndex.baseHigh}
    `;

    return (
        <>
            <css.wrapper data-cy='popupAfterAdvertise'>
                <MobilePopup showClass={showClass} close={close} dataCyName={'PromotionPopup'} title={undefined} list={undefined} forwardRef={undefined} TopComponent={null}>
                    <css.main>
                        <css.title>{t('pageIsLive')}</css.title>
                        <css.text>{t('pageIsLiveText')}</css.text>
                        <css.icon />
                    </css.main>
                    <>
                        <CustomScrollbar contentRef={refContent} cssStyle={cssStyle} maxBottom={65}/>
                        <css.body ref={refContent}>
                            <css.buttons>
                                {btnArr.map((btn, index) => (
                                    <Btn key={index} onClick={btn.onClick} className={btn.className} disabled={btn.disabled}>
                                        <css.btnIcon className={btn.className} $icon={btn.icon}/>
                                        {btn.text}
                                    </Btn>
                                ))}
                            </css.buttons>
                            <PublicationSection />
                            <PromotionSection showPromotionPopup={showPromotionPopup} showPromotion={showPromotion} colors={colors} />
                            <css.wrapCheckbox>
                                <Checkbox   
                                    classes={''}
                                    selected={hidePublishPopup}
                                    onClick={()=> updateHidePublishPopup({hidePublishPopup: !hidePublishPopup})}
                                    color={DEFAULT_COLOR}
                                />
                                {t('doNotShowAgain')}
                            </css.wrapCheckbox>
                        </css.body>
                        <BottomSection  />
                        {shareShow.isOpen &&
                            <CustomSharePopup show={shareShow} />
                        }
                    </>
                </MobilePopup>
            </css.wrapper>
            {QRShow.isOpen && <QrCodePopup {...QRShow} url={getQrCodeUrl()} />}
        </>
    );
};

export default AdvertiseContent;
